/* global $, window, document */
import StickySidebar from 'sticky-sidebar';

const sidepanelBreakPointMql = 	window.matchMedia('(min-width: 1200px)');

let $sidepanel;
let $backdrop;
let $trigger;

function init() {

	$sidepanel = $('.page-side-panel');
	$backdrop = $('.page-side-panel__backdrop');
	$trigger = $('.top-bar__toggle');

	$trigger.on('click', () => {
		toggle();
	});

	$backdrop.on('click', () => {
		close();
	});

	handleSticky(sidepanelBreakPointMql);

	sidepanelBreakPointMql.addListener((mql) => {
		close();
		handleSticky(mql);
	});

}

function show() {

	$sidepanel.removeClass('is--hidden');
	$trigger.removeClass('is--hidden');

	$(document.body).addClass('u--body-lock page-side-panel--open');

}

function close() {

	$sidepanel.addClass('is--hidden');
	$trigger.addClass('is--hidden');

	$(document.body).removeClass('u--body-lock page-side-panel--open');

}

function toggle() {

	if ($sidepanel.hasClass('is--hidden')) {
		show();
	} else {
		close();
	}

}

function handleSticky(mql) {
	if (mql.matches) {
		window.greenledStickySidepanel = window.greenledStickySidepanel || new StickySidebar('.page-side-panel', {
			containerSelector: '.page-wrap',
			innerWrapperSelector: '.page-side-panel__content'
		});
	} else if (window.greenledStickySidepanel) {
		window.greenledStickySidepanel.destroy();
		window.greenledStickySidepanel = null;
	}
}

export default {
	init
};
